import DiagnosticTree from './components/DiagnosticTree'
import MobilePhotoCapture from './components/MobilePhotoCapture'

function App() {
  // Check for mobile photo capture mode
  const params = new URLSearchParams(window.location.search)
  const photoMode = params.get('photo')
  const peerIdParam = params.get('peer')

  // If photo=1 and peer ID present, show mobile photo capture
  if (photoMode === '1' && peerIdParam) {
    return <MobilePhotoCapture peerId={peerIdParam} />
  }

  return <DiagnosticTree />
}

export default App
